module.exports = __webpack_public_path__ + "791b1d2d1822c00161a3442c968cd8b3.svg";